// Extracted from the inline block in theme.liquid so it can be deferred.
// Deferred scripts execute in document order, so this runs after
// animations.min.js (which provides gsap + plugins) and before
// slideshow.js / app.js / product.js, matching the original behavior.
gsap.defaults({
  ease: Power4.easeOut,
});
gsap.config({
  nullTargetWarn: false,
});
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);
